export default {
    WEAK: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    EXCELLENT: 10,
    NONE: 11,
}